import { render, staticRenderFns } from "./LocationSkeleton.vue?vue&type=template&id=c1991c2a&scoped=true&"
import script from "./LocationSkeleton.vue?vue&type=script&lang=js&"
export * from "./LocationSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./LocationSkeleton.vue?vue&type=style&index=0&id=c1991c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1991c2a",
  null
  
)

export default component.exports